const { DEFAULT_RUNSTYLE } = require('../../Shape/AbstractShape/config/defaultStyles');
const { sameRunStyleInTextBodies } = require('../utils');

exports.computeFontStyleFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(
    textBodies,
    'font.style',
    DEFAULT_RUNSTYLE.font.style,
    { skipUndefined: false, textSelection }
);
